
import { baseUrl } from '@/utils/global'
export default {
    method: 'get',
    // 基础url前缀
    baseUrl: baseUrl,
    // 请求头信息
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    },
    // 参数cmpm
    data: {},
    params: {},
    // 设置超时时间
    timeout: 60000,
    // 让ajax携带cookie
    withCredentials: false,
    // 返回数据类型
    responseType: 'json'
}



// WEBPACK FOOTER //
// ./src/http/config.js